/**
 * author: Soumya Shreyas
 */
import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { withTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import MessageModal from "../../../components/MessageModal/MessageModal";
import PhoneNumber from "../../../components/PhoneNumber/PhoneNumber";
import CompanyService from "../../../core/service/CompanyService";
import InvitationService from "../../../core/service/InvitationService";
import UtilsService from "../../../core/service/UtilsService";
import Validations from "../../../core/utilities/Validations";
import "./CompanyCreate.scss";
import UserService from "../../../core/service/UserService";
import Multiselect from 'multiselect-react-dropdown';

function CompanyCreate({ t }) {
	const location = useLocation();
	const data = location.state;
	const navigate = useNavigate();
	const [pageStatus, setPageStatus] = useState(data ? "Edit" : "Create");
	const [companyLegalName, setCompanyLegalName] = useState(
		data ? data.legalName : ""
	);
	const [invitationId, setInvitationId] = useState(data ? data.id : "");
	const [email, setEmail] = useState(data ? data.email : "");
	const [contact, setContact] = useState(data ? data.contactNumber.number : "");
	const [phoneCodeCountry, setPhoneCodeCountry] = useState(
		data ? data.contactNumber.code.name : ""
	);
	const [defaultContactCode, setDefaultContactCode] = useState(
		data ? data.contactNumber.code.id : ""
	);
	const [defaultContactId, setDefaultContactId] = useState(
		data ? data.contactNumber.id : ""
	);
	const [phoneCode, setPhoneCode] = useState([]);
	const [contactCode, setContactCode] = useState("");
	const [contactPerson, setContactPerson] = useState(data ? data.name : "");
	const [sendInvite, setSendInvite] = useState(false);
	const [show, setShow] = useState(false);
	const [responseMsg, setResponseMsg] = useState({ for: '', message: '' });
	const [showCreateCompany, setShowCreateCompany] = useState(false);
	const [validated, setValidated] = useState(false);
	const [onboardForCompany, setOnboardForCompany] = useState(false);
	const [allGroups, setAllGroups] = useState([]);
	const [selectedGroups, setSelectedGroups] = useState([]);

	useEffect(() => {
		getPhoneCodes();
		getGroups();

	}, []);

	useEffect(() => {
        if (pageStatus === 'Edit' && allGroups.length > 0) {
            getSavedGroupsByInvitationId();
        } 
    }, [pageStatus, allGroups.length]); 

	const getSavedGroupsByInvitationId = () => {
		InvitationService.getInvitationById(invitationId).then(res => {
			const savedGroupNames = res.data?.groups || [];
		  const matchedGroupNames = allGroups
		  .filter(group => 
			  savedGroupNames.some(savedName => 
				  savedName === group.name
			  )
		  )
		  .map(group => group.name); 

	  setSelectedGroups(matchedGroupNames);
			
		}).catch(error => {
			toast.error(error.title, {
				position: toast.POSITION.TOP_RIGHT,
			});
		});
	}
	const getPhoneCodes = () => {
		UtilsService.getPhoneCodes()
			.then((response) => {
				setPhoneCode([...response.data]);
			})
			.catch((error) => {
			});
	};

	const handleClose = () => setShow(false);
	const handleCompanyClose = () => setShowCreateCompany(false);

	const handleCreate = (e) => {
		e.preventDefault();
		const form = e.currentTarget;

		if (form.checkValidity() === false || !Validations.isValidEmail(email)) {
			e.stopPropagation();
		} else {
			setShowCreateCompany(true);
		}
		setValidated(true);
	};
	const getPhoneCodeVal = (data) => {
		if (data.length > 0) {
			setContactCode(data[0].id);
		}
	};
	const getPhoneNumberVal = (data) => {
		setContact(data);
	};
	const handleConfirm = (e) => {
		setShowCreateCompany(false);
		if (pageStatus === "Edit") {
			const params = {
				id: invitationId,
				legalName: companyLegalName,
				name: contactPerson,
				email: email,
				contactNumber: {
					// id: item.phoneNumber.code.id,
					code: {
						id: contactCode,
					},
					number: contact,
				},
				sendInvite: sendInvite,
				supplierType: null,
				onboardForCompany: onboardForCompany,
				groups: selectedGroups
			};
			updateCompany(params, invitationId);
		} else {
			const companyDetails = {
				name: contactPerson,
				legalName: companyLegalName,
				email: email,
				contactNumber: {
					code: {
						id: contactCode,
					},
					number: contact,
				},
				sendInvite: sendInvite,
				onboardForCompany: onboardForCompany,
				groups: selectedGroups
			};
			CompanyService.createCompany(companyDetails)
				.then((response) => {
					if (response.status === 201) {
						toast.success("Success", {
							position: toast.POSITION.TOP_RIGHT,
						});
						if (onboardForCompany) {
							setResponseMsg({ for: 'PASSWORD', message: response.data.initialPassword });
						} else {
							navigate("/admin/list_company");
						}
					}
				})
				.catch((error) => {
					toast.dismiss();
					var errorRes = error.response;
					if (errorRes.status === 400) {
						setResponseMsg({ for: 'ERROR', message: errorRes.data.message });
						setShow(true);
					}
				});
		}
	};
	const updateCompany = (params, invitationId) => {
		InvitationService.updateCompanyInvitation(params, invitationId)
			.then((response) => {
				if (response.status === 200) {
					toast.success("Success", {
						position: toast.POSITION.TOP_RIGHT,
					});
					navigate("/admin/list_company");
				}
			})
			.catch((error) => { });
	};
	var title;
	pageStatus === "Edit"
		? (title = t("EditCompany.label"))
		: (title = t("CreateCompany.label"));

	const renderCompanyUpdateConfirmationModal = () => {
		return (
			<Modal show={showCreateCompany} onHide={handleCompanyClose}>
				<Modal.Header closeButton>
					< Modal.Title as="h5">{t("CreateCompany.label")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{pageStatus === "Create"
						? t("NewCompanyNamed.label") +
						" " +
						companyLegalName +
						" " +
						t("WillbeCreated.label") +
						"  "
						: companyLegalName + " " + t("WillbeUpdated.label") + "  "}
					{sendInvite &&
						t("and.label") + " " + t("InvitationSend.label") + " " + email}
					{onboardForCompany && t("OnboardCompanyHelper.label")}
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="secondary"
						onClick={handleCompanyClose}
						autoFocus
					>
						{t("Discard.label")}
					</Button>

					<Button variant="primary" onClick={handleConfirm} className="sbmBtn">
						{t("Confirm.label")}
					</Button>
				</Modal.Footer>
			</Modal>
		);
	};
//To get the groups
	const getGroups = () => {
		UserService.getAllowedRoles().then(res => {
			setAllGroups(res.data?.allGroups || []);
			if (res.status === 200) {
				console.log("res.data?.allGroups",res.data?.allGroups);
				
			}
		}).catch(error => {
			toast.error(error.title, {
				position: toast.POSITION.TOP_RIGHT,
			});
		});
	}

	const groupOptions = allGroups.map(group => ({
		id: group.id,
		name: group.name
	}));

	const selectedGroupObjects = allGroups
		.filter(group => selectedGroups.includes(group.name))
		.map(group => ({
			id: group.id,
			name: group.name
		}));
	const handleGroupSelect = (selectedList) => {
		const groupName = selectedList.map(item => item.name);
		setSelectedGroups(groupName);
	};

	const handleGroupRemove = (selectedList) => {
		const groupName = selectedList.map(item => item.name);
		setSelectedGroups(groupName);
	};
	//end of group selector

	return (
		<section>
			<div className="Main_body">
				<div className="Company_formBox col-lg-6">
					<div className="List_header">
						<h5 className="MH">{title}</h5>
					</div>
					<Form noValidate validated={validated} onSubmit={handleCreate}>
						{/* <form onSubmit={handleCreate}> */}
						<div className="mb-4 row mx-0">
							<div className="col-lg-12 p-2">
								<label className="mb-1">
									{t("CompanyLegalName.label")} *
								</label>
								<input
									type="text"
									className="form-control"
									value={companyLegalName}
									onChange={(e) => setCompanyLegalName(e.target.value)}
									required
								/>
							</div>
							<div className="col-lg-12 p-2">
								<label className="mb-1">{t("Emailid.label")} *</label>
								<input
									type="email"
									className="form-control"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									required
								/>
							</div>
							<div className="col-lg-12 p-2">
								<label className="mb-1">
									{t("ContactPerson.label")} *
								</label>
								<input
									type="text"
									className="form-control"
									value={contactPerson}
									onChange={(e) => setContactPerson(e.target.value)}
									required
								/>
							</div>
							<div className="col-lg-12 p-2">
								<label className="mb-1">
									{t("ContactNumber.label")} *
								</label>
								<div className="row px-1">
									<PhoneNumber
										onCodeSelected={getPhoneCodeVal}
										phoneNumber={getPhoneNumberVal}
										codelabel={t("phoneCode.label")}
										contact={contact}
										defaultContactCode={defaultContactCode}
										phoneCodeCountry={phoneCodeCountry}
										defaultContactId={defaultContactId}
									/>
								</div>
							</div>
							<div className="col-lg-12 p-2">
                                    <label className="mb-1">{t("Roles.label")} *</label>
                                   {/* Group Selector */}
								   <Multiselect
                                        options={groupOptions}
                                        selectedValues={selectedGroupObjects}
                                        displayValue="name"
                                        required
                                        showArrow={false}
                                        closeOnSelect={false}
                                        onSelect={handleGroupSelect}
                                        onRemove={handleGroupRemove}
                                        style={{ chips: { maxWidth: '200px', whiteSpace: 'normal' } }}
                                    />
                                    </div>
							<div className="col-lg-12 p-3">
								<Form.Check
									inline
									label={t("CompanySendInvitation.label")}
									name="comp1"
									type="radio"
									id="inline-1"
									checked={sendInvite && !onboardForCompany}
									onChange={() => {
										setSendInvite(true);
										setOnboardForCompany(false);
									}}
								/>
								<Form.Check
									inline
									label={t("OnboardCompany.label")}
									name="comp1"
									type="radio"
									id="inline-2"
									checked={onboardForCompany && !sendInvite}
									onChange={() => {
										setOnboardForCompany(true);
										setSendInvite(false);
									}}
								/>
							</div>
						</div>
						<div className="text-center">
							<button
								type="submit"
								className="btn btn-secondary me-2"
								onClick={() => {
									navigate(`/admin/list_company`);
								}}
							>
								{t("Cancel.label")}
							</button>
							{data ? (
								<button type="submit" className="btn  btn-primary px-4 sbmBtn">
									{t("Update.label")}
								</button>
							) : (
								<button type="submit" className="btn  btn-primary px-4 sbmBtn">
									{t("Create.label")}
								</button>
							)}
						</div>
					</Form>
					{renderCompanyUpdateConfirmationModal()}
					{
						responseMsg?.message && 
						<MessageModal
							modalShow={true}
							messageText={responseMsg.message}
							callbackModal={(val, id) => {
								if (val && responseMsg?.for === 'PASSWORD') {
									navigate("/admin/list_company");
								} else {
									setResponseMsg({});
								}
							}}
							copiableText={responseMsg?.for === 'PASSWORD'}
							secondaryButtonText={t('CopyPassword.label')}
							title={responseMsg?.for === 'PASSWORD' ? t('InitialPassword.label') : ''}
						/>
					}
				</div>
			</div>
		</section>
	);
}

export default withTranslation()(CompanyCreate);
